import i18n from "i18next";

export function getLanguageFromLocale(locale: string | undefined) {
  switch (locale) {
    case "GB":
      return "en";
    case "US":
      return "en";
    case "PL":
      return "pl";
  }

  return i18n.language;
}
